import useStore from '@/stores/useStore';
import { useCallback, useRef, useEffect } from 'react';

export const useScrollToTop = (delay = 100) => {
  const scrollRef = useStore((state) => state.scrollRef);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  // Clear any pending timeout on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, []);

  return useCallback(() => {
    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    timeoutRef.current = setTimeout(() => {
      scrollRef?.current?.scrollTo({ x: 0, y: 0, animated: true });
      timeoutRef.current = null;
    }, delay);
  }, [scrollRef, delay]);
};
